import script from "./batch-device.vue?vue&type=script&lang=ts&setup=true"
export * from "./batch-device.vue?vue&type=script&lang=ts&setup=true"

import "./batch-device.vue?vue&type=style&index=0&id=d3ab9e02&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3ab9e02"]])

export default __exports__